<template>
  <div
    v-if="maintenanceNotification"
    :class="`alert notification-${maintenanceNotification.type}`"
    role="alert"
  >
    <div
      class="alert-text"
      v-html="maintenanceNotification.message"
    />
  </div>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/auth'
import { storeToRefs } from 'pinia'

const { maintenanceNotification } = storeToRefs(useAuthStore())
</script>
